module.exports = __webpack_public_path__ + "img/NG.ea284e80.png";